import React from 'react';
import { Button, Stack } from '@mui/material';
import ReplyIcon from '@mui/icons-material/Reply';

interface IListToolbarProps {
  search: React.ReactNode;
  filters: React.ReactNode;
  actions: React.ReactNode;
  isDefault: boolean;
  onReset: () => void;
  children?: React.ReactNode;
}

export const ListToolbar: React.FC<IListToolbarProps> = ({
  search,
  filters,
  actions,
  isDefault,
  onReset,
  children,
}) => (
  <Stack gap={1.5} px={2}>
    <Stack
      direction="row"
      gap={1}
      alignItems="center"
      flexWrap="wrap"
      sx={{ '& > *': { maxWidth: '100%' } }}
    >
      {search}

      {filters}

      <Stack
        direction="row"
        gap={1}
        alignItems="center"
        flexWrap="wrap"
        sx={{ ml: 'auto' }}
      >
        {actions}

        <Button
          variant="text"
          size="small"
          disabled={isDefault}
          startIcon={<ReplyIcon />}
          onClick={onReset}
          sx={{
            minHeight: '2.5rem',
            color: 'text.secondary',
            textTransform: 'none',
            whiteSpace: 'nowrap',
          }}
        >
          Reset
        </Button>
      </Stack>
    </Stack>

    {children}
  </Stack>
);
